module.exports = __webpack_public_path__ + "static/media/operation-service.e2bce858.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/operation-service.jpg
// module id = 577
// module chunks = 0